import { Component, EventEmitter, forwardRef, HostBinding, Input, Output, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import {NgbDropdown} from '@ng-bootstrap/ng-bootstrap';

interface Idata {
  month: number;
  year: number;
}
@Component({
  selector: 'app-month-input',
  templateUrl: './month-input.component.html',
  styleUrls: ['./month-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MonthInputComponent),
      multi: true
    }
  ]
})
export class MonthInputComponent implements ControlValueAccessor {

  data: Idata;
  dataTxt: string;
  separator: string;
  monthFirst: boolean;
  place: number;

  isyear=false;
  incr=0;


  months: string[] = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
  // Allow the input to be disabled, and when it is make it somewhat transparent.
  @Input() disabled = false;
  @Input() mask = 'mm/yyyy';

  @Input() readonly id: string;
  @Input() readonly title: string;

  @Input() readonly isInvalid: boolean = false;

  @Output() readonly itemSelect = new EventEmitter<any>();

  @ViewChild('calendarPanel') calendar: NgbDropdown;

  constructor() {
    this.separator = this.mask.replace(/m|y|M/gi, '');
    this.monthFirst = this.mask.indexOf('y') > 0;
    this.place = this.mask.indexOf(this.separator);
  }

  change(value: string) {
    value=this.separator===' '?value.replace(/\.|-|\//,' '):
      this.separator==='/'?value.replace(/\.|-| /,'/'):
        this.separator==='-'?value.replace(/\.| |\//,'-'):
          value.replace(/.| |\//,'-');

    const lastchar = value.substr(value.length - 1);
    if (lastchar === this.separator && value.length <= this.place) {
      if (this.monthFirst) {
        value = '0' + value;
      }
    }
    if (value.length > this.place && value.indexOf(this.separator) < 0) {
      value = value.substr(0, value.length - 1) + this.separator + lastchar;
    }
    this.dataTxt = value;
    const items = value.split(this.separator);
    const year = this.monthFirst ? items[1] : items[0];
    const month = this.monthFirst ? items[0] : items[1];

    let imonth = this.months.indexOf(month);
    if ((imonth) < 0) {
      imonth = parseInt(month,10);
    } else {
      imonth = imonth + 1;
    }
    let iyear = parseInt(year,10);

    if (items.length !== 2 || !/^\d*$/.test(items[0])  || !/^\d*$/.test(items[1]) ) {
      this.data = {
        year: (new Date()).getFullYear(),
        month: null
      };
    } else {
      if (iyear < 100) {
        iyear = iyear + 2000;
      }
      this.data = {
        year: iyear,
        month: imonth
      };
      this.incr=this.getIncr(this.data.year);
    }
    this.itemSelect.emit(this.data);
    this.writeValue(this.data);
  }
  selectYearMonth($event,index:number){
    if (this.isyear) {
      $event.stopPropagation();
      this.data.year=index+this.incr;
      this.dataTxt=this.formatData(this.data);
      this.isyear=false;
      this.incr=this.getIncr(this.data.year);
    } else {
      this.data.month=index+1;
      this.dataTxt=this.formatData(this.data);
      this.itemSelect.emit(this.data);
      this.writeValue(this.data);
    }
  }
  showYear($event:any,show:boolean) {
    $event.stopPropagation();
    this.isyear=!this.isyear;
  }
  addYear($event:any,incr:number) {
    $event.stopPropagation();
    const year=this.isyear?this.data.year+10*incr:this.data.year+incr;
    this.data.year=year;
    this.incr=this.getIncr(year);
    // this.dataTxt=this.formatData(this.data);
  }
  onChange = (data: Idata) => {
    this.data = data;
    const month: string = data.month ? data.month.toString() : '';
    const year: string = data.year ? data.year.toString() : '';
    if(month || year){
      this.dataTxt = this.monthFirst ? '' + month + this.separator + year :
        '' + year + this.separator + month;
    } else {
      this.dataTxt = '';
    }
    if(!this.data.year){
      this.data.year = (new Date()).getFullYear();
    }
    this.incr=this.getIncr(this.data.year);

  }

  getIncr(year:number):number {
    return (year-year%10)-1;
  }
  formatData(data:Idata):string {
    const monthTxt = data.month<10? '0'+data.month:'' + data.month;
    return  this.monthFirst ?  monthTxt+ this.separator + data.year :
      '' + data.year + this.separator + monthTxt;

  }
  // Function to call when the input is touched (when a star is clicked).
  onTouched = () => { };

  writeValue(data: Idata): void {
    this.data = data;
    this.onChange(this.data);
  }

  // Allows Angular to register a function to call when the model (rating) changes.
  // Save the function as a property to call later here.
  registerOnChange(fn: (data: Idata) => void): void {
    this.onChange = fn;
  }

  // Allows Angular to register a function to call when the input has been touched.
  // Save the function as a property to call later here.
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  // Allows Angular to disable the input.
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
  onFocusOut(item: string) {
    if(this.data.year === null || this.data.month === null){
      this.dataTxt = '';
    }
    this.itemSelect.emit(this.data);
  }

}
